import { useMemo } from 'react';

import qs from 'qs';

import { useTracking } from '@change-corgi/core/react/tracking';

import { useHomepagePageData } from 'src/app/pages/homepage/pageContext';
import { generateAiSapParam } from 'src/app/shared/utils/generateAiSapParam';

type Result = ModelHookResult<
	{
		primaryCtaUrl: string;
		secondaryCtaUrl: string;
		totalUserCount: { total: number; totalLocalized: string };
	},
	{
		onPrimaryCtaClick: () => void;
		onSecondaryCtaClick: () => void;
	}
>;

export function useSapCtas(): Result {
	const track = useTracking();

	const {
		data: { totalUserCount, aiSapId },
	} = useHomepagePageData();

	const primaryCtaUrl = '/start-a-petition/intro?source_location=homepage_primary_button';
	const secondaryCtaUrl = useMemo(
		() =>
			`/start-a-petition/intro?${qs.stringify({ state: generateAiSapParam(aiSapId), source_location: 'homepage_secondary_button' })}`,
		[aiSapId],
	);

	return {
		actions: {
			onPrimaryCtaClick: () => {
				void track('homepage_SAP_click', {
					cta: 'primary',
				});
			},
			onSecondaryCtaClick: () => {
				void track('homepage_SAP_click', {
					cta: 'secondary',
				});
			},
		},
		data: {
			primaryCtaUrl,
			secondaryCtaUrl,
			totalUserCount,
		},
	};
}
